module.exports = __webpack_public_path__ + "624ef7cfb7e77903679b02537aa9f51c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/dinercount.png
// module id = 736
// module chunks = 0